import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/header/header.component';
import { FooterComponent } from "./shared/footer/footer.component";
import { ScrollToTopComponent } from "./shared/scroll-to-top/scroll-to-top.component";
import { LoaderComponent } from './shared/loader/loader.component';
import { MetaService } from './shared/services/meta.service';
import { LoaderService } from './shared/services/loader.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, ScrollToTopComponent, LoaderComponent, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected title = 'superLawyer';
  selectedCategorySlug = '';

  constructor(
    private readonly router: Router,
    private metaService: MetaService,
    public loaderService: LoaderService
  ) {}

  ngOnInit() {
    // // Set default meta tags for the application
    // this.metaService.setDefaultMetaTags();
  }

  onCategorySelected(slug: string) {
    this.selectedCategorySlug = slug;
    this.router.navigate(['/interviews', slug]);
  }
}
